import type { Ref } from 'vue'

/** The payload key the render clock travels under. */
export const RENDER_CLOCK_STATE = 'render-clock'

/**
 * The moment the page was built, in milliseconds, for anything that says how
 * long ago something happened.
 *
 * A rendered page is cached for a group and served for up to a minute, so the
 * browser hydrates HTML that was built earlier. A label like "9h" computed
 * against the machine clock then disagrees the moment an hour boundary passes
 * between the render and the hydration, and Vue reports a text mismatch on
 * every card that crossed one. Formatting against this clock instead keeps the
 * browser on the server's moment while it hydrates. plugins/render-clock.client.ts
 * moves it to the live clock once hydration is over, which re-renders the labels
 * as an ordinary update rather than a mismatch.
 *
 * On a page the browser built itself the state starts at the browser's own
 * clock, which is what those labels used before.
 */
export function useRenderClock(): Ref<number> {
  return useState<number>(RENDER_CLOCK_STATE, () => Date.now())
}
